import { render } from "./Resto.vue?vue&type=template&id=14d214b5&scoped=true"
import script from "./Resto.vue?vue&type=script&lang=js"
export * from "./Resto.vue?vue&type=script&lang=js"

import exportComponent from "/home/q4-cockpitmdwareorg/q4-cockpit.mdware.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d214b5"]])

export default __exports__